import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "social-youtube_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 4.3c.02 0 6.882 0 8.595.46a2.756 2.756 0 0 1 1.945 1.945c.456 1.709.46 5.268.46 5.295 0 0 0 3.58-.46 5.296a2.755 2.755 0 0 1-1.945 1.944c-1.713.46-8.575.46-8.595.46 0 0-6.88 0-8.595-.46a2.755 2.755 0 0 1-1.945-1.944C1 15.58 1 12 1 12c0-.027.002-3.586.46-5.295A2.756 2.756 0 0 1 3.405 4.76C5.121 4.3 12 4.3 12 4.3Zm-2.202 11 5.716-3.3-5.716-3.299V15.3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }